import "./styles.scss";
import React, { memo, useEffect, useState } from "react";
import { calculateTimeLeft } from "../../utils/utils";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

interface TypeCircleNumber {
  contestLiveTime?: any;
}

const TimeLeft = ({ expiryTime }) => {
  const { minutes, seconds } = calculateTimeLeft(expiryTime);

  return (
    <div className="content-circle-number">{minutes > 0 ? `${minutes}:` : ''}{`${seconds}`.padStart(2, '0')}</div>
  );
};

const CircleNumber: React.FC<TypeCircleNumber> = ({
  contestLiveTime,
}) => {
  const [initialRemainingTime, setInitialRemainingTime] = useState<number>(0)

  useEffect(() => {
    const time = calculateTimeLeft(contestLiveTime);
    setInitialRemainingTime(time.seconds)
  }, [contestLiveTime]);

  if (!initialRemainingTime) {
    return <></>;
  }

  return (
    <div className="wrapper-circle-number">
      <div className="background-circle-number">
        <CountdownCircleTimer
          isPlaying
          rotation={"counterclockwise"}
          duration={60}
          initialRemainingTime={initialRemainingTime}
          strokeWidth={20}
          colors="#141c29bf"
          onComplete={() => ({ shouldRepeat: true })}
        >{({ remainingTime }) => <TimeLeft expiryTime={contestLiveTime} />}</CountdownCircleTimer>
      </div>
    </div>
  );
};

export default memo(CircleNumber);
